export default "__VITE_ASSET__DlxezCEH__"